export default __webpack_public_path__ + "static/media/logo_hubertus.27122e4d.png";